import './page/synonym-source-list';

Shopware.Module.register('topdata-es-synonym-source', {
    type: 'plugin',
    name: 'Synonym Sources',
    title: 'TopdataEnhancedSearchSW6.topdata-es-synonym-source.title',
    description: 'TopdataEnhancedSearchSW6.topdata-es-synonym-source.description',
    color: '#189eff',
    icon: 'default-shopping-search',

    routes: {
        list: {
            component: 'topdata-es-synonym-source-list',
            path: 'list',
            meta: {
                privilege: 'system.zero_search.viewer',
            },
        },
    },

    navigation: [{
        id: 'topdata-es-synonym-source-list',
        label: 'TopdataEnhancedSearchSW6.topdata-es-synonym-source.listTitle',
        color: '#189eff',
        path: 'topdata.es.synonym.source.list',
        parent: 'topdata-es',
    }],
});
